import { useEffect } from 'react';
import { isUserTyping } from 'src/utils/is-user-typing';
import analyticsClient, { AnalyticsEvent } from 'src/services/analytics';

type Props = {
    isFilterOpen: boolean;
    setFilterOpen: (open: boolean) => void;
};

/**
 * Open or close the filter modal when the 'F' key is pressed.
 */
export const useToggleFilterModalWithFKey = ({ isFilterOpen, setFilterOpen }: Props) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.ctrlKey || event.altKey || event.metaKey) {
                return;
            }

            if (isUserTyping()) {
                return;
            }

            if (event.key === 'f' || event.key === 'F') {
                analyticsClient.track(AnalyticsEvent.SHORTCUT_KEY_USED, {
                    page: 'Conversations',
                    key: 'F',
                });

                event.preventDefault();
                setFilterOpen(!isFilterOpen);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isFilterOpen, setFilterOpen]);
};
